import styled from "styled-components";
import { Link, getLinkColors } from "@evergis/ui";

export const StyledCopyrightsContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  font-size: 10px;
  padding: 3px 2px 2px 4px;
`;

export const StyledCopyrightContainer = styled.div<{ backgroundColor?: string; color?: string }>`
  display: flex;
  background-color: ${props => props.backgroundColor || "rgba(255, 255, 255, 0.36)"};
  color: ${props => props.color || "rgba(0, 0, 0, 0.54)"};
  user-select: none;

  &:not(:last-child):after {
    content: "|";
    margin: 0 5px;
  }
`;

export const StyledCopyrightLink = styled(Link).attrs(() => ({ target: "_blank" }))`
  font-size: 10px;
  margin-left: 0.25rem;

  &:visited {
    color: ${({ theme: { link }, ...props }) => link.color[getLinkColors(props)]};
  }
`;
